import { Pipe, PipeTransform } from "@angular/core";

export interface DurationConfig {
  showHours?: boolean;
  showMinutes?: boolean;
  showSeconds?: boolean;
}

@Pipe({
  name: "duration",
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(milliseconds: number, config: DurationConfig = {}): string {
    // Set default values for each time component to be shown unless explicitly turned off
    const showHours = config.showHours !== false;
    const showMinutes = config.showMinutes !== false;
    const showSeconds = config.showSeconds !== false;

    let totalSeconds = Math.floor(milliseconds / 1000);
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = (totalSeconds % 60).toString().padStart(2, "0");

    // Handle cases based on what is shown
    if (!showHours && showMinutes && showSeconds) {
      // Accumulate hours into minutes if hours are off
      minutes += hours * 60;
      hours = 0;
    } else if (!showHours && !showMinutes && showSeconds) {
      // Accumulate everything into seconds if both hours and minutes are off
      totalSeconds = Math.floor(milliseconds / 1000);
      seconds = totalSeconds.toString();
      return seconds;
    }

    let result = "";

    if (showHours && hours > 0) {
      result += hours.toString().padStart(2, "0");
    }
    if (showMinutes) {
      result += (result ? ":" : "") + minutes.toString().padStart(2, "0");
    }
    if (showSeconds) {
      result += (result ? ":" : "") + seconds;
    }

    return result || `${hours}:${minutes}:${seconds}`; // Fallback to HH:mm:ss if all are false
  }
}
